import { RouterProvider } from "react-router-dom";
import { createAppRouter } from "./router/appRouter";
import { Toaster } from "react-hot-toast";
import "./App.css";

const router = createAppRouter();

const App = () => {
  return (
    <>
      <Toaster
        position="top-center"
        containerStyle={{
          zIndex: 9999999,
        }}
        toastOptions={{
          duration: 3000,
          style: {
            borderRadius: "12px",
            background: "#fff",
            color: "#1a2340",
            textAlign: "center"
          },
        }}
      />

      <RouterProvider router={router} />
    </>
  )
};

export default App;